import {isProduction} from './isProduction';

const LOG_PREFIX = '[stripe-cookies]';

const loggedMessages = new Set<string>();

// The any[] type is the same type as the console.error/warn type,
// so we're just carrying that forward to this helper method.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const error = (message: string, ...args: any[]) => {
  if (!isProduction) {
    const key = (() => {
      try {
        return `${message}::${JSON.stringify(args)}`;
      } catch {
        return message;
      }
    })();

    if (loggedMessages.has(key)) {
      return;
    }

    loggedMessages.add(key);
    console.error(`${LOG_PREFIX} ${message}`, ...args); // eslint-disable-line no-console
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const warn = (message: string, ...args: any[]) => {
  if (!isProduction) {
    const key = (() => {
      try {
        return `${message}::${JSON.stringify(args)}`;
      } catch {
        return message;
      }
    })();

    if (loggedMessages.has(key)) {
      return;
    }

    loggedMessages.add(key);
    console.warn(`${LOG_PREFIX} ${message}`, ...args); // eslint-disable-line no-console
  }
};

const reset = () => {
  loggedMessages.clear();
};

export const log = {warn, error, reset} as const;
